import { useCallback } from 'react';
import { useDisclosure } from '@bitrise/bitkit';
import { useMutateUserMetadata } from '@/hooks/api/useUserMetadata';

const useWorkflowInfoHighlight = (
  workflowsInfoShown: boolean,
  currentPage: 'Builds' | 'Artifacts',
  hasAnyBuild?: boolean,
) => {
  const { mutate } = useMutateUserMetadata();
  const { onClose: onHelpClose, isOpen } = useDisclosure({
    defaultIsOpen: !workflowsInfoShown && !hasAnyBuild && currentPage === 'Builds',
  });

  const onWorkflowInfoClose = useCallback(() => {
    onHelpClose();
    mutate({ app_details_workflow_product_info_shown: true });
  }, [mutate, onHelpClose]);

  return {
    onWorkflowInfoClose,
    isWorkflowInfoVisible: isOpen,
  };
};

export default useWorkflowInfoHighlight;
